import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import './TauriSearchConfigure.css';
import { Label } from 'reactstrap';

const TauriSearchConfigure = ({ show, onHide, onUpdate, data, selectedConfig, selectedIds }) => {
    const [expandedNodes, setExpandedNodes] = useState([]);
    const [localSelectedIds, setLocalSelectedIds] = useState([]);

    useEffect(() => {
        // Initialize localSelectedIds with selectedIds to pre-check checkboxes
        setLocalSelectedIds(selectedIds || []);
    }, [selectedIds]);

    const handleCheckboxChange = (id) => {
        setLocalSelectedIds(prevSelected =>
            prevSelected.includes(id)
                ? prevSelected.filter(item => item !== id)
                : [...prevSelected, id]
        );
    };

    const handleNodeToggle = (nodeName) => {
        setExpandedNodes(prevExpanded =>
            prevExpanded.includes(nodeName)
                ? prevExpanded.filter(name => name !== nodeName)
                : [...prevExpanded, nodeName]
        );
    };

    const TreeNode = ({ node }) => {
        const hasItems = node.items && node.items.length > 0;
        const isExpanded = expandedNodes.includes(node.name);

        return (
            <div className="tree-node">
                <div className="node" onClick={() => handleNodeToggle(node.name)}>
                    <span className={`icon-header ${isExpanded ? 'up' : 'right'}`}>&#9658;</span>
                    {node.name}
                </div>
                {isExpanded && hasItems && (
                    <div className="children">
                        {node.items.map((item, index) => (
                            <div key={index} className='searchconfig-row'>
                                <div className='searchconfig-cell'>
                                    <input
                                        type="checkbox"
                                        className="circle-checkbox"
                                        checked={localSelectedIds.includes(item.id)}
                                        onChange={() => handleCheckboxChange(item.id)}
                                    />
                                </div>
                                <div className='searchconfig-cell'>
                                    {item.name}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    };

    const handleUpdate = () => {
        onUpdate(localSelectedIds);
    };

    return (
        <Modal show={show} onHide={onHide} className="tauri-search-configuration">
            <Modal.Header className='section-modal-header'>
                <Label>Configure {selectedConfig === 'sections' ? 'Reference File' : 'Transaction'} Search</Label>
            </Modal.Header>
            <Modal.Body className='section-modal-body'>
                <div className="tree-container">
                    {data && data.length > 0 ? (
                        <div className="tree-container">
                            {data.map((node, index) => (
                                <TreeNode key={index} node={node} />
                            ))}
                        </div>
                    ) : (
                        <Label>No data available</Label>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer className='section-modal-footer'>
                <Button className='search-configBtn' onClick={handleUpdate}>Update</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TauriSearchConfigure;
